import { render, staticRenderFns } from "./PrivacyPolicyPage.vue?vue&type=template&id=8f6c4eba&scoped=true&"
import script from "./PrivacyPolicyPage.vue?vue&type=script&lang=js&"
export * from "./PrivacyPolicyPage.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyPolicyPage.vue?vue&type=style&index=0&id=8f6c4eba&lang=scss&scoped=true&"
import style1 from "./PrivacyPolicyPage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f6c4eba",
  null
  
)

export default component.exports